<template>
    <div>
        <o-field label="Violation Number *" :type="fieldType('violation_number')" :message="getError('application_number')">
            <o-input placeholder="Violation Number" v-model="form.violation_number"/>
        </o-field>

        <o-field label="Type of Violation *" :type="fieldType('type')" :message="getError('type')">
            <o-select placeholder="Select a Type" v-model="form.type" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="type in violationTypes"
                    :value="type.id"
                    :key="type.id">
                    {{ type.name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Description *" :type="fieldType('description')" :message="getError('description')">
            <o-input maxlength="200" v-model="form.description" type="textarea"></o-input>
        </o-field>

        <o-field label="Hearing Date *" :type="fieldType('hearing_date')" :message="getError('hearing_date')">
          <Datepicker
              v-model="form.expiration_date"
              class="input"
              :config="{ enableTime: true }"
              placeholder="Pick a Date"/>
        </o-field>

        <o-field label="Respondents *" :type="fieldType('respondent_id')" :message="getError('respondent_id')">
            <o-select placeholder="Select a respondent" v-model="form.respondent_id" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="respondent in respondents"
                    :value="respondent.id"
                    :key="respondent.id"
                >
                    {{ respondent.full_name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Status of Violation *" :type="fieldType('status')" :message="getError('status')">
            <o-select placeholder="Select a Status" v-model="form.status" expanded>
                <option
                    v-for="status in violationStatuses"
                    :value="status.id"
                    :key="status.id">
                    {{ status.name }}
                </option>
            </o-select>
        </o-field>
    </div>
</template>

<script>
    import Application from '../../../mixins/Application'
    import HandlesForm from '../../../mixins/HandlesForm'
    import Datepicker from './../../../components/Datepicker'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [Application, HandlesForm],

        components: {
            Datepicker
        },

        data () {
            return {
                form: {
                    violation_number: null,
                    respondent_id: null,
                    hearing_date: null,
                    description: null,
                    status: null,
                    type: null
                }
            }
        },

        computed: {
            ...mapGetters({
                violationStatuses: 'violationStatuses',
                violationTypes: 'violationTypes',
                respondents: 'contacts'
            })
        }
    }
</script>
